import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { UspBlockComponent } from "./usp-block/usp-block.component";

@NgModule({
  imports: [CommonModule, TranslateModule.forChild()],
  declarations: [UspBlockComponent],
  exports: [UspBlockComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UspBlockModule {}
